import React, { useState } from "react";
import TooltipPortal from "../TooltipPortal/TooltipPortal";
import { normalizePriority, PRIORITY_TIPS } from "./tableViewHelpers";

export default function PriorityBadge({ priority }) {
  const pNorm = normalizePriority(priority) || "medium"; // "low" | "medium" | "high"
  const label = pNorm.charAt(0).toUpperCase() + pNorm.slice(1); // Title Case

  const tips = PRIORITY_TIPS[pNorm] || [];
  const [tipIndex, setTipIndex] = useState(0);
  const message = tips.length ? tips[tipIndex % tips.length] : label;

  return (
    <TooltipPortal label={message} offsetY={28}>
      <span
        className={`tableview-priority-badge ${pNorm}`}
        onMouseEnter={() =>
          tips.length && setTipIndex((i) => (i + 1) % tips.length)
        }
      >
        {label}
      </span>
    </TooltipPortal>
  );
}
